import { FeaturesCon, RightCon, RightItem, Tag } from "./style";
import { Spacer } from "../../atoms";
import { Png } from "../../../assets/Png";
import "react-multi-carousel/lib/styles.css";
import { Title } from "../SeamlessShoping/style";
import { Carousel } from "@mantine/carousel";
import { useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import AutoPlay from "embla-carousel-autoplay";
import { useRef } from "react";

export const MadinaFeatures = () => {
  const { featureImg2, featureImg5 } = Png;
  const theme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
  const large = useMediaQuery(`(max-width: ${theme.breakpoints.lg})`);
  const autoplay = useRef(AutoPlay({ delay: 4000 }));

  return (
    <FeaturesCon>
      <RightCon>
        <Title>What We Offer</Title>
        <Spacer height="32px" />
        <Carousel
          loop
          plugins={[autoplay.current]}
          onMouseEnter={autoplay.current.stop}
          onMouseLeave={autoplay.current.reset}
          slidesToScroll={mobile ? 1 : large ? 2 : 3}
          slideSize={mobile ? "90%" : large ? "50%" : "33%"}
          slideGap={mobile ? "11px" : large ? "22px" : "32px"}
        >
          <Carousel.Slide>
            <RightItem color="#DAEEFA" position="right" bg={featureImg5}>
              <Tag color="#2F4DC4">
                <p>Money back</p>
              </Tag>
              <Spacer height="12px" />
              <div className="text">
                <p className="title">
                  Shop and Earn <br /> money back
                </p>
                <Spacer height="12px" />

                <p className="desc">
                  Earn points any time you <br /> complete your shopping on{" "}
                  <br />
                  Madina.
                </p>
              </div>
            </RightItem>
          </Carousel.Slide>

          <Carousel.Slide>
            <RightItem color="#EDFAEF" position="right" bg={featureImg2}>
              <Tag color="#1AB66E">
                <p>Madina Loyaty</p>
              </Tag>
              <Spacer height="12px" />
              <div className="text">
                <p className="title">Refer and Earn</p>
                <Spacer height="12px" />

                <p className="desc">
                  Share your referral code and earn <br /> amazing rewards.{" "}
                </p>
              </div>
            </RightItem>
          </Carousel.Slide>

        </Carousel>
      </RightCon>
    </FeaturesCon>
  );
};
